import Moment from "moment";

export const transactionMainRowTransformer = (transactionListData) => {
  const returnValueMainRow = { ...transactionListData.transactionList };
  returnValueMainRow.requestCreated = Moment(
    returnValueMainRow.requestCreated
  ).format("LL");
  const subRowData = { ...transactionListData.transactionsParts };
  if (subRowData !== undefined) {
    returnValueMainRow.expand = true;
    if (returnValueMainRow.paymentAmount < 0) {
      returnValueMainRow.cssClass = "ReversePaymentClassName";
    } else {
      returnValueMainRow.cssClass = "";
    }
  } else {
    returnValueMainRow.expand = false;
    returnValueMainRow.cssClass = "";
  }
  return returnValueMainRow;
};
